import React from 'react'

import { ITokenData } from './auth.interface'

type AuthContextProps = {
  token: string
  setToken: (token: string) => void
  tokenData: ITokenData
  setTokenData: (tokenData: ITokenData) => void
}

const AuthContext = React.createContext<AuthContextProps>({
  token: '',
  setToken: () => {},
  tokenData: {
    accounts: [],
    iat: 0,
    roles: [],
    sub: '',
  },
  setTokenData: () => {},
})

export const AuthProvider = AuthContext.Provider
export const AuthConsumer = AuthContext.Consumer
export default AuthContext
